import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterMenuProps {
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
}

/** Dashed "Label: **Value**" filter chip opening a Radix dropdown of options. */
export function FilterMenu({ label, value, options, onChange }: FilterMenuProps) {
  const current = options.find((option) => option.value === value)?.label ?? value;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex h-8 items-center gap-1.5 rounded-lg border border-dashed border-ds-line2 bg-transparent px-2.5 font-ds text-[13px] text-ds-ink2 transition-colors hover:bg-ds-sunk focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-accent"
        >
          {label}: <b className="font-semibold text-ds-ink">{current}</b>
          <ChevronDown className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="border-ds-line bg-ds-panel font-ds text-ds-ink">
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {options.map((option) => (
            // An explicit name: the checked item's dot must never stand in for (or blank) its label.
            <DropdownMenuRadioItem key={option.value} value={option.value} aria-label={option.label} className="text-[13px]">
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
